import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject, OnDestroy,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoginStatus } from '../data-access/login.service';
import { LoginConfig } from '@shared-interfaces/shared-login';
import { animate, style, transition, trigger } from '@angular/animations';
import { environment } from '@environments/environment';

@Component({
  standalone: true,
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('500ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @Input({ required: true }) loginStatus!: LoginStatus;
  @Input({ required: false }) loginConfig!: LoginConfig | undefined;
  @Output() login = new EventEmitter<string>();

  private fb = inject(FormBuilder);

  authProviders: string[] = [];

  loginForm = this.fb.nonNullable.group({
    email: [''],
    password: [''],
  });

  onProviderSelect(provider: string): void {
    this.login.emit(provider);
  }

  getProviderDisplayName(provider: string): string {
    // Generate display name dynamically from provider string with proper case
    const name = provider.replace('oidc.', '');
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  ngOnInit(): void {
    document.body.style.backgroundColor = 'black';
    // Initialize auth providers from environment, filtering out undefined values
    this.authProviders = environment.authParams
      .filter((provider: any) => provider && typeof provider === 'string')
      .map((provider: any) => provider as string);
  }

  ngOnDestroy(): void {
    document.body.style.backgroundColor = 'white';
  }
}
